import log from 'loglevel';
// Set default log level (can be overridden by environment or config)
log.setLevel(process.env.NODE_ENV === 'production' ? 'warn' : 'debug');
export default log;
